export default __webpack_public_path__ + "static/media/PortalDashboard.154e4cbd.JPG";